export default "__VITE_ASSET__6Tst9aOo__"